<div class="market-insights-container">
  <div class="header-section">
    <h2>Market Insights</h2>

    <div class="header-actions">
      <div class="countdown-timer">
        <mat-icon class="timer-icon">schedule</mat-icon>
        <span class="countdown-text">Auto-refresh in: <strong>{{ countdownDisplay }}</strong></span>
      </div>

      <button mat-raised-button color="primary" (click)="onManualRefresh()" [disabled]="gridInProgress">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="filter-section">
      <!-- <mat-form-field appearance="outline" class="alert-type-filter">
        <mat-label>Filter by Alert Type</mat-label>
        <mat-select [formControl]="alertTypeController">
          <mat-option *ngFor="let option of alertTypeOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      <div class="form-group" style="margin-bottom: 0">
        <input class="form-control" placeholder="Search by Stock..." [formControl]="stockCodeController" />
      </div>
      <div class="language-switcher" style="margin-left: 0">
        <div class="language-buttons">
        <button
            *ngFor="let option of alertTypeOptions"
            type="button"
            class="language-btn"
            [class.active]="alertTypeController.value === option.value"
            (click)="alertTypeController.setValue(option.value)">
            {{ option.label }}
          </button>
        </div>
      </div>
      <div class="language-switcher">
        <!-- <span class="language-label">Language:</span> -->
        <div class="language-buttons">
          <button
            *ngFor="let option of langTypes"
            type="button"
            class="language-btn"
            [class.active]="langController.value === option.value"
            (click)="langController.setValue(option.value)">
            {{ option.label }}
          </button>
        </div>
      </div>
  </div>

  <div class="table-container">
    <div *ngIf="gridInProgress" class="loading-overlay">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <table class="market-insights-table">
      <tr class="mat-mdc-header-row">
        <th class="mat-mdc-header-cell">#</th>
        <th class="mat-mdc-header-cell">Stock </th>
        <th class="mat-mdc-header-cell">Insight</th>
        <th class="mat-mdc-header-cell">Topic</th>
        <th class="mat-mdc-header-cell">Alert Type</th>
        <th class="mat-mdc-header-cell">Created At</th>
      </tr>
      <tbody>
        <tr class="mat-mdc-row" *ngFor="let stockData of marketInsights; let i = index;">
          <td>{{i + 1}}</td>
          <td style="width: 10%">{{stockData?.stock_code}}</td>
          <td style="width: 45%">{{langController.value === 'en' ? stockData?.insight_text : stockData?.insight_text_bn}}</td>
          <td style="width: 15%">{{langController.value === 'en' ? stockData?.topic : stockData?.topic_bn}}</td>
          <td style="width: 10%">{{stockData?.alert_type}}</td>
          <td style="width: 10%">{{stockData?.timestamp_string}}</td>
        </tr>
      </tbody>
<!--      &lt;!&ndash; Row Number Column &ndash;&gt;-->
<!--      <ng-container matColumnDef="rowNo">-->
<!--        <th mat-header-cell *matHeaderCellDef>#</th>-->
<!--        <td mat-cell *matCellDef="let insight; let i = index">{{ i + 1 }}</td>-->
<!--      </ng-container>-->

<!--      &lt;!&ndash; Stock Column &ndash;&gt;-->
<!--      <ng-container matColumnDef="stock">-->
<!--        <th mat-header-cell *matHeaderCellDef mat-sort-header>Stock</th>-->
<!--        <td mat-cell *matCellDef="let insight">{{ insight.stock_code || '-' }}</td>-->
<!--      </ng-container>-->

<!--      &lt;!&ndash; Insight Column &ndash;&gt;-->
<!--      <ng-container matColumnDef="insight">-->
<!--        <th mat-header-cell *matHeaderCellDef mat-sort-header>Insight</th>-->
<!--        <td mat-cell *matCellDef="let insight">{{ insight.insight_text || '-' }}</td>-->
<!--      </ng-container>-->

<!--      &lt;!&ndash; Topic Column &ndash;&gt;-->
<!--      <ng-container matColumnDef="topic">-->
<!--        <th mat-header-cell *matHeaderCellDef mat-sort-header>Topic</th>-->
<!--        <td mat-cell *matCellDef="let insight">{{ insight.topic || '-' }}</td>-->
<!--      </ng-container>-->

<!--      &lt;!&ndash; Alert Type Column &ndash;&gt;-->
<!--      <ng-container matColumnDef="alertType">-->
<!--        <th mat-header-cell *matHeaderCellDef mat-sort-header>Alert Type</th>-->
<!--        <td mat-cell *matCellDef="let insight">{{ insight.alert_type || '-' }}</td>-->
<!--      </ng-container>-->

<!--      <ng-container matColumnDef="timestamp_string">-->
<!--        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>-->
<!--        <td mat-cell *matCellDef="let insight">{{ insight.timestamp_string || '-' }}</td>-->
<!--      </ng-container>-->

<!--      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>-->
<!--      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>-->

      <!-- No data row -->
      <tr class="mat-row" *ngIf="marketInsights?.length === 0">
        <td class="mat-cell" [attr.colspan]="6">
          <div class="no-data-message">
            No market insights data available
          </div>
        </td>
      </tr>
    </table>

    <!-- length: {{marketInsightsPageGrid?.dataSource.length}} -->

    <!-- Pagination -->
    <!-- <mat-paginator
      *ngIf="marketInsightsPageGrid"
      [pageSizeOptions]="pageSizes"
      [pageSize]="marketInsightsPageGrid.pageSize"
      [length]="marketInsightsPageGrid.total"
      [pageIndex]="marketInsightsPageGrid.pageIndex"
      (page)="marketInsightsPageGrid.onPaginate($event)"
      showFirstLastButtons
      aria-label="Select page of market insights"
    >
    </mat-paginator> -->
  </div>
</div>

